import FormArchives from '../../DAL/FormArchives'
import { getDocs, collection } from 'firebase/firestore'
import {store} from '../utilities'
import {category} from '../action_creators'

export default function readActions(archiveId, formId) {
  return function () {
    if (!formId) return
    async function fetch() {
      const formArchives = new FormArchives()
      const snap = await getDocs(collection(formArchives.docRef(archiveId), 'actions'))
      const actions = snap.docs.map((d) => ({id: d.id, ...d.data()}))
      store.dispatch(category('saveAction')(actions))
    }
    fetch()
  }
}
